"use client"
/* */
import { jsxs, jsx } from 'react/jsx-runtime';
import { flowComponent } from '../../lib/componentFactory/flowComponent.mjs';
import 'react';
import * as Aria from 'react-aria-components';
import formFieldStyles from '../FormField/FormField.module.scss.mjs';
import styles from './SegmentedControl.module.scss.mjs';
import { getContainerBreakpointSizeClassName } from '../../lib/getContainerBreakpointSizeClassName.mjs';
import '../../lib/propsContext/propsContext.mjs';
import '../../lib/viewComponentContext/viewComponentContext.mjs';
import { PropsContextProvider } from '../../lib/propsContext/PropsContextProvider.mjs';
import { TunnelProvider, TunnelExit } from '@mittwald/react-tunnel';
import { FieldError } from '../FieldError/FieldError.mjs';
import clsx from 'clsx';

const SegmentedControl = flowComponent("SegmentedControl", (props) => {
  const {
    children,
    className,
    containerBreakpointSize = "m",
    ref,
    ...rest
  } = props;
  const rootClassName = clsx(
    formFieldStyles.formField,
    styles.segmentedControlContainer,
    className,
    styles[getContainerBreakpointSizeClassName(containerBreakpointSize)]
  );
  const propsContext = {
    Label: {
      className: formFieldStyles.label
    },
    FieldDescription: {
      className: formFieldStyles.fieldDescription,
      tunnelId: "fieldDescription"
    },
    FieldError: {
      className: formFieldStyles.customFieldError,
      tunnelId: "fieldError"
    },
    Segment: {
      tunnelId: "segments",
      className: styles.segment
    }
  };
  return /* @__PURE__ */ jsxs(Aria.RadioGroup, { ...rest, className: rootClassName, ref, children: [
    /* @__PURE__ */ jsx(TunnelProvider, { children: /* @__PURE__ */ jsxs(
      PropsContextProvider,
      {
        dependencies: ["segment"],
        props: propsContext,
        mergeInParentContext: true,
        children: [
          children,
          /* @__PURE__ */ jsx("div", { className: styles.segmentedControl, children: /* @__PURE__ */ jsx("div", { className: styles.segments, children: /* @__PURE__ */ jsx(TunnelExit, { id: "segments" }) }) }),
          /* @__PURE__ */ jsx(TunnelExit, { id: "fieldDescription" }),
          /* @__PURE__ */ jsx(TunnelExit, { id: "fieldError" })
        ]
      }
    ) }),
    /* @__PURE__ */ jsx(FieldError, { className: formFieldStyles.fieldError })
  ] });
});

export { SegmentedControl, SegmentedControl as default };
//# sourceMappingURL=SegmentedControl.mjs.map
